import * as React from "react"
const CornerNegative = (props) => {
	return <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M 0 8 Q 0 0, 8 0 L 0 0 "  strokeWidth="1"/>
	</svg>
}
export default CornerNegative
